import { Platform, StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    container: {
        backgroundColor: "white",
        borderRadius: theme.spacing.xsmall2,
        ...Platform.select({
            web: {
                paddingHorizontal: theme.spacing.xsmall,
                height: theme.spacing.xlarge,
                borderWidth: 1,
                borderColor: theme.colors.greyscale.lighter,
                justifyContent: "center",
            },
            android: {
                borderWidth: 1,
                borderColor: theme.colors.greyscale.lighter,
                paddingRight: 0,
            },
            ios: {},
        }),
    },
    picker: Platform.select({
        web: {
            borderWidth: 0,
        },
        default: {},
    }),
    items: {
        fontSize: theme.fontDefaults.small.fontSize,
        height: 150,
    },
    disabledIOSView: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: 150,
    },
    loading: {
        backgroundColor: theme.colors.greyscale.light,
    },
});
//# sourceMappingURL=InputSelect.styles.js.map